import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { SecureCallSchema } from "../../Schemas/SecureCalls";

interface Filter extends IFilterSchema {
  column: SecureCallColumnFilterable;
}

interface Sort extends ISortSchema {
  column: SecureCallColumnSortable;
}

export enum SecureCallColumnFilterable {
  FIRST_SIDE_NUMBER = "first_side_number",
  SECOND_SIDE_NUMBER = "second_side_number",
  STATUS = "status",
  RECORD_CALL = "record_call",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
  ESTIMATED_COST = "estimated_cost",
  ACTUAL_COST = "actual_cost",
  WORKSPACE_ID = "workspace_id"
}

export enum SecureCallColumnSortable {
  ID="id",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
  START_TIME = "start_time",
  ANSWER_TIME = "answer_time",
  END_TIME = "end_time",
  DURATION_SECONDS = "duration_seconds",
  ESTIMATED_COST = "estimated_cost",
  ACTUAL_COST = "actual_cost",
}
interface SecureCallsListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface SecureCallsListResponseBody extends IResponseBody {
  data: {
    secure_calls: SecureCallSchema[];
    total: number;
  };
}

export class SecureCallsListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/secure-calls`;
  }

  async send(
    queryStrings?: SecureCallsListQueryString
  ): Promise<SecureCallsListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(),
        {
          params: queryStrings,
        }
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
